// src/ForceDeleteModal/ForceDeleteModal.tsx
import * as React from "react";
import Alert from "@cloudscape-design/components/alert";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useAppTranslation } from "@amzn/awsmp-max-translations";
import { jsx, jsxs } from "react/jsx-runtime";
var ForceDeleteModal = ({ projects, onConfirm, onCancel }) => {
  const { t } = useAppTranslation();
  const [isDeleting, setIsDeleting] = React.useState(false);
  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } catch (_err) {
      setIsDeleting(false);
    }
  };
  return /* @__PURE__ */ jsxs(SpaceBetween, { size: "m", children: [
    /* @__PURE__ */ jsx(Box, { children: projects.length === 1 ? t("forceDeleteProjectProcessing") : t("forceDeleteProjectsProcessing", {
      count: projects.length,
      plural: projects.length === 1 ? t("project") : t("projects")
    }) }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx("ul", { style: { margin: 0, paddingLeft: "20px" }, children: projects.map((project) => /* @__PURE__ */ jsx("li", { children: project.name }, project.id)) }) }),
    /* @__PURE__ */ jsx(Alert, { type: "warning", children: projects.length === 1 ? t("forceDeleteWarningOne") : t("forceDeleteWarning", {
      count: projects.length,
      plural: projects.length === 1 ? t("project") : t("projects")
    }) }),
    /* @__PURE__ */ jsxs(SpaceBetween, { size: "xs", direction: "horizontal", children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancel, disabled: isDeleting, children: t("cancel") }),
      /* @__PURE__ */ jsx(Button, { variant: "primary", loading: isDeleting, onClick: handleConfirm, children: t("deleteAnyway") })
    ] })
  ] });
};
export {
  ForceDeleteModal
};
//# sourceMappingURL=index.js.map
